// src/api/axiosConfig.js

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:8080',
});

// 요청 인터셉터 (기존과 동일)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// [수정] 응답 인터셉터
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized request. Dispatching logout event.');

      // 1. 로컬 스토리지에서 토큰 제거
      localStorage.removeItem('token');

      // 2. 'unauthorized' 커스텀 이벤트를 발생시켜 App 컴포넌트에 알림
      //    이렇게 하면 React 외부 모듈이 React 상태에 영향을 줄 수 있습니다.
      window.dispatchEvent(new Event('unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;